import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pageoverlay-loader',
  templateUrl: './pageoverlay-loader.component.html',
  styleUrls: ['./pageoverlay-loader.component.scss']
})
export class PageoverlayLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
